// extracted by mini-css-extract-plugin
module.exports = {"coreList":"list_coreList__rpnS5"};